<template>
  <div class="usercenter">
    <!-- 没有登入信息 -->

    <div class="noLogin" v-if="!userInfo && !wishInfo">
      <span class="iconfont icon-fanhui back" @click="goback"></span>
      <img src="../../assets/mescroll/mescroll-empty.png" alt />
      <div>
        <van-radio-group v-model="islogin" direction="horizontal">
          <van-radio name="1">会员登入</van-radio>
          <van-radio name="2">爱心企业登入</van-radio>
        </van-radio-group>
      </div>
      <p>
        您还没有登入，请先
        <span style="color:#DD2828" @click="toLogin">登入</span>
      </p>
    </div>
    <!-- 登入的用户信息 -->
    <div class="alreadyLogin" v-if="userInfo && !wishInfo">
      <!-- <h2 class="tit">个人信息</h2> -->
      <div class="moreHead"></div>
      <div class="headTitle">
        <span @click="goback">
          <van-icon name="arrow-left" color="#000" class />
        </span>
        <span>个人信息</span>
        <span class="status">&nbsp;&nbsp;</span>
      </div>
      <div class="itemList">
        <span>头像</span>
        <img :src="userInfo.avatar?userInfo.avatar:require('../../assets/images/yonghu.png')" alt />
      </div>
      <!-- @click="nickNameShow=true" -->
      <div class="itemList">
        <span>昵称</span>
        <span>{{nickname}}</span>
      </div>
      <div class="itemList">
        <span>手机号</span>
        <span>{{ userInfo.phone }}</span>
      </div>
      <div class="itemList" @click="isMywish">
        <span>我的心愿</span>
      </div>
      <div class="btncon">
        <van-button
          type="danger"
          round
          size="small"
          class="loginOut"
          @click="loginOut('huiyuan')"
        >退出登入</van-button>
      </div>
    </div>
    <!-- 登陆的爱心企业信息 -->
    <div class="alreadyLogin" v-if="wishInfo && !userInfo">
      <!-- <h2 class="tit">我的信息</h2> -->
      <div class="moreHead"></div>
      <div class="headTitle">
        <span @click="goback">
          <van-icon name="arrow-left" color="#000" class />
        </span>
        <span>企业信息</span>
        <span class="status">&nbsp;&nbsp;</span>
      </div>
      <div class="itemList">
        <span>名称</span>
        <span>{{ wishInfo.name }}</span>
      </div>
      <div class="itemList">
        <span>联系人</span>
        <span>{{ wishInfo.contactPeople }}</span>
      </div>
      <div class="itemList">
        <span>手机号</span>
        <span>{{ wishInfo.phone }}</span>
      </div>
      <div class="btncon">
        <van-button type="danger" round size="small" class="loginOut" @click="loginOut('qiye')">退出登录</van-button>
      </div>
    </div>
    <!-- <van-dialog v-model="nickNameShow" title="修改昵称" show-cancel-button @confirm="editName">
      <van-field v-model="newNickName" placeholder="请输入新昵称" input-align	="center" />
    </van-dialog>-->
  </div>
</template>

<script>
export default {
  data() {
    return {
      userInfo: null,
      wishInfo: null,
      nickNameShow: false,  // 昵称修改弹框
      nickname: '',
      newNickName: '',      // 用户输入的新昵称
      islogin: '2', // 选择登入哪里
      dataSetinterval: null // 信息定时器
    };
  },
  mounted() {
    if (window.localStorage.enterpriseInfo && window.localStorage.enterpriseInfo != 'undefined') { // 爱心企业登入
      this.wishInfo = JSON.parse(window.localStorage.enterpriseInfo);
      this.userInfo = null;
    } else
      if (window.localStorage.personalInformation && window.localStorage.personalInformation != 'undefined') {  // 会员登入
        this.wishInfo = null;
        this.userInfo = JSON.parse(window.localStorage.personalInformation);
      } else { // 都没登入
        this.wishInfo = null;
        this.userInfo = null;
      }

    if (JSON.parse(window.localStorage.userinfo).id) { // 如果有用户id说明是会员 爱心企业中没有存id
      this.dataSetinterval = setInterval(() => {
        if (window.localStorage.personalInformation && window.localStorage.personalInformation != 'undefined') {
          this.wishInfo = null;
          this.userInfo = JSON.parse(window.localStorage.personalInformation);
          clearInterval(this.dataSetinterval);
        }
      }, 500);
    }

  },
  methods: {
    goback() {
      this.$router.go(-1); //返回上一级
    },
    // 调到登入
    toLogin() {
      if (this.islogin == 1) { // 跳app的登入
        this.login();
      } else { // 爱心企业登入
        this.$router.push("/login");
      }
    },
    //退出登录
    loginOut(value) {
      if (value == 'huiyuan') { // 会员退出
        // window.localStorage.personalInformation = JSON.stringify(undefined); // 会员退出
        this.currency('toLogout', '');
      } else { // 爱心企业退出
        this.wishInfo = null;
        this.userInfo = null;
        window.localStorage.enterpriseInfo = JSON.stringify(undefined); // 爱心企业退出
        window.localStorage.oldWishToken = '';
        window.localStorage.oldenterpriseInfo = '';
        window.localStorage.userinfo = '';
        if (window.localStorage.personalInformation && window.localStorage.personalInformation != 'undefined') {  // 会员登入
          this.userInfo = JSON.parse(window.localStorage.personalInformation);
        }
      }
    },
    isMywish() { // 我的心愿
      var link = window.location.href.split("#/")[0] + "#/mywish"; //登入页
      this.linkPhone({ url: link, title: '我的心愿' });
      // $router.push('/mywish')
    }
  },
};
</script>

<style lang="less">
.headTitle {
  height: 10vw;
  background: #eeeeee;
  padding-top: env(safe-area-inset-top);
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 0.32rem;
  color: #000;
  padding: 0px 10px;
  > span {
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
.moreHead {
  width: 100%;
  height: 7vw;
  background: #eeeeee;
}
.noLogin {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  align-content: center;
  p {
    margin-top: 10px;
    width: 100%;
    text-align: center;
  }
}
.usercenter {
  .back {
    font-size: 20px;
    position: absolute;
    left: 10px;
    top: 40px;
    z-index: 999;
  }
  .btncon {
    display: flex;
    justify-content: center;
    margin-top: 6vw;
    .loginOut {
      padding: 0.5vw 3.5vw;
      font-size: 0.27rem;
      margin: auto;
    }
  }

  .tit {
    text-align: center;
    height: 30px;
    line-height: 30px;
    padding: 5px 0;
    margin-top: 15px;
  }
  .itemList {
    margin: 3vw 0;
    background: #fff;
    display: flex;
    justify-content: space-between;
    padding: 3vw 4vw;
    box-sizing: border-box;
    font-size: 0.27rem;
    img {
      width: 4vw;
      height: 4vw;
    }
  }
  background: #fafafa;
}
</style>